var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconExchange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 589 589",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-1,.cls-2,.cls-3{stroke-width:0px;}.cls-2{fill:#fff;}.cls-4{clip-path:url(#clippath);}.cls-3{fill:#4289c8;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 589,
    height: 589
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_-_arrows"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18329"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32429",
    className: "cls-3",
    d: "M0,294.5C0,131.85,131.85,0,294.5,0s294.5,131.85,294.5,294.5-131.85,294.5-294.5,294.5C131.93,588.81.19,457.07,0,294.5M562.37,294.5c0-147.94-119.93-267.87-267.87-267.87S26.63,146.56,26.63,294.5s119.93,267.87,267.87,267.87c147.87-.16,267.71-120,267.87-267.87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32430",
    className: "cls-2",
    d: "M346.33,522.93l97.9-117.95c2.02-2.54,2.46-6,1.13-8.96-1.38-2.98-4.37-4.9-7.66-4.91h-40.25v-152.7c.12-6.78-5.29-12.36-12.06-12.48s-12.36,5.29-12.48,12.06v169.34c0,4.66,3.78,8.44,8.44,8.44h22.09l-63.46,76.45-63.46-76.45h22.09c4.66-.01,8.43-3.79,8.44-8.44v-209.54h40.25c3.29-.01,6.27-1.92,7.66-4.91,1.31-2.97.87-6.42-1.15-8.96l-97.9-117.95c-2.99-3.58-8.31-4.06-11.89-1.07-.39.32-.74.68-1.07,1.07l-97.87,117.8c-1.25,1.52-1.94,3.43-1.94,5.4,0,1.24.27,2.46.79,3.58,1.38,2.98,4.37,4.9,7.66,4.91h40.25v152.58c0,6.78,5.49,12.27,12.27,12.27,3.21,0,6.29-1.24,8.59-3.48,2.38-2.31,3.73-5.49,3.73-8.81v-168.58c0-4.66-3.78-8.44-8.44-8.44h-22.09l63.46-76.45,63.46,76.45h-22.09c-4.66.01-8.43,3.79-8.44,8.44v209.51h-40.25c-4.68.02-8.45,3.83-8.43,8.51,0,1.95.69,3.83,1.92,5.34l97.9,117.95c2.98,3.59,8.3,4.07,11.89,1.09.4-.33.76-.7,1.09-1.09"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExchange);
export default __webpack_public_path__ + "static/media/icon-exchange.534fdb8ddc504f6355ffaeb5a6e8048e.svg";
export { ForwardRef as ReactComponent };